import React from 'react'

interface EmsLogoProps {
  size?: 'sm' | 'md' | 'lg' | number
  showText?: boolean
  className?: string
  style?: React.CSSProperties
}

export default function EmsLogo({
  size = 'md',
  showText = false,
  className = '',
  style = {}
}: EmsLogoProps) {
  let dimension = 44
  if (typeof size === 'number') {
    dimension = size
  } else if (size === 'sm') {
    dimension = 32
  } else if (size === 'md') {
    dimension = 44
  } else if (size === 'lg') {
    dimension = 72
  }

  const svgLogo = (
    <svg
      width={dimension}
      height={dimension}
      viewBox="0 0 240 240"
      style={{ display: 'block', flexShrink: 0, ...style }}
      className={className}
    >
      <defs>
        <linearGradient id="emsGradComp" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF7A00" />
          <stop offset="50%" stopColor="#FF5500" />
          <stop offset="100%" stopColor="#D84315" />
        </linearGradient>
      </defs>

      {/* Orange Rounded Badge */}
      <rect x="10" y="10" width="220" height="220" rx="46" fill="url(#emsGradComp)" />
      <rect x="18" y="18" width="204" height="204" rx="38" fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="3" />

      {/* Graduation Cap Icon */}
      <path d="M120 50 L172 76 L120 102 L68 76 Z" fill="#FFFFFF" />
      <path d="M162 82 V102 C162 112 143 120 120 120 C97 120 78 112 78 102 V82" fill="none" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" />
      <path d="M172 76 V111" fill="none" stroke="#FFE0B2" strokeWidth="4" strokeLinecap="round" />
      <circle cx="172" cy="113" r="4" fill="#FFE0B2" />

      {/* EMS Text */}
      <text x="120" y="182" fontFamily="'Outfit', 'Inter', sans-serif" fontSize="56" fontWeight="900" fill="#FFFFFF" textAnchor="middle" letterSpacing="3">EMS</text>
    </svg>
  )

  if (!showText) {
    return svgLogo
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
      {svgLogo}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontSize: `${Math.max(14, dimension * 0.4)}px`, fontWeight: 900, color: '#0f172a', letterSpacing: '-0.3px', lineHeight: 1.1 }}>
          EMS
        </span>
        <span style={{ fontSize: '10px', color: '#ff5500', fontWeight: 800, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
          Exam Management System
        </span>
      </div>
    </div>
  )
}
